import { APIOptions } from 'primereact/api';

export const primereactConfig: Partial<APIOptions> = {
  ripple: false,
};
